"use strict";

(function () {
  function initAppSlider(config) {
    var wrapper = document.querySelector(config.selector);
    if (!wrapper) return;

    var prefix = config.prefix;
    var scope = wrapper.closest("section") || document;
    var container =
      wrapper.querySelector("." + config.containerClass) || wrapper;
    var track = wrapper.querySelector("[data-" + prefix + "-track]");
    var slides = wrapper.querySelectorAll("[data-" + prefix + "-slide]");
    var dots = scope.querySelectorAll("[data-" + prefix + "-dot]");
    var prevBtn = wrapper.querySelector("[data-" + prefix + "-prev]");
    var nextBtn = wrapper.querySelector("[data-" + prefix + "-next]");

    if (!slides.length) return;

    var totalSlides = slides.length;
    var currentSlide = 0;
    var THROTTLE_MS = 650;
    var throttleTimer = null;
    var wheelActive = false;
    var settling = false;
    var wasInView = false;
    var sectionObs = null;

    var isProgrammaticScroll = false;
    var scrollTimeout = null;

    var updateDots = function (idx) {
      dots.forEach(function (d, i) {
        d.classList.toggle("is-active", i === idx);
        d.setAttribute("data-distance", Math.abs(i - idx));
      });

      if (prevBtn) {
        prevBtn.classList.toggle("is-disabled", idx === 0);
      }

      if (nextBtn) {
        nextBtn.classList.toggle("is-disabled", idx === totalSlides - 1);
      }
    };

    var updateActive = function (idx, dir) {
      slides.forEach(function (s, i) {
        if (i === idx) {
          s.classList.toggle("from-above", dir < 0);
          s.classList.add("is-active");
        } else {
          s.classList.remove("is-active", "from-above");
        }
      });
      updateDots(idx);
    };

    var scrollToSlide = function (idx) {
      if (!track) return;
      var slideEl = slides[idx];
      if (!slideEl) return;

      isProgrammaticScroll = true;
      clearTimeout(scrollTimeout);

      track.scrollTo({
        left: slideEl.offsetLeft - track.offsetLeft,
        behavior: "smooth",
      });

      scrollTimeout = setTimeout(function () {
        isProgrammaticScroll = false;
      }, 500);
    };

    var getNextSlideIndex = function () {
      if (!track) return Math.min(currentSlide + 1, totalSlides - 1);
      var currentScroll = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (currentScroll >= maxScroll - 5) {
        return totalSlides - 1;
      }

      for (var i = 0; i < totalSlides; i++) {
        var slideOffset = slides[i].offsetLeft - track.offsetLeft;
        if (slideOffset > currentScroll + 5) {
          return i;
        }
      }
      return totalSlides - 1;
    };

    var getPrevSlideIndex = function () {
      if (!track) return Math.max(currentSlide - 1, 0);
      var currentScroll = track.scrollLeft;

      if (currentScroll <= 5) {
        return 0;
      }

      for (var i = totalSlides - 1; i >= 0; i--) {
        var slideOffset = slides[i].offsetLeft - track.offsetLeft;
        if (slideOffset < currentScroll - 5) {
          return i;
        }
      }
      return 0;
    };

    var getActiveIndexFromScroll = function () {
      if (!track || !slides.length) return 0;
      var trackLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (maxScroll > 0 && trackLeft >= maxScroll - 10) {
        return totalSlides - 1;
      }
      if (trackLeft <= 10) {
        return 0;
      }

      var minDiff = Infinity;
      var activeIdx = 0;

      slides.forEach(function (slide, i) {
        var diff = Math.abs(slide.offsetLeft - track.offsetLeft - trackLeft);
        if (diff < minDiff) {
          minDiff = diff;
          activeIdx = i;
        }
      });

      return activeIdx;
    };

    var onTrackScroll = function () {
      if (isProgrammaticScroll) return;
      var idx = getActiveIndexFromScroll();
      if (idx !== currentSlide) {
        currentSlide = idx;
        updateDots(currentSlide);
      }
    };

    var isInView = function () {
      var rect = container.getBoundingClientRect();
      var mid = rect.top + rect.height / 2;
      var center = window.innerHeight * 0.5;
      return Math.abs(mid - center) < window.innerHeight * 0.2;
    };

    var onWheel = function (e) {
      if (!isInView()) {
        wasInView = false;
        return;
      }

      var dir = e.deltaY > 0 ? 1 : -1;

      if (dir > 0 && currentSlide >= totalSlides - 1) {
        wasInView = false;
        return;
      }
      if (dir < 0 && currentSlide <= 0) {
        wasInView = false;
        return;
      }

      e.preventDefault();

      if (!wasInView) {
        wasInView = true;
        settling = true;
        setTimeout(function () {
          settling = false;
        }, 400);
      }

      if (settling || throttleTimer) return;

      currentSlide += dir;
      updateActive(currentSlide, dir);
      throttleTimer = setTimeout(function () {
        throttleTimer = null;
      }, THROTTLE_MS);
    };

    var activateWheel = function () {
      if (wheelActive) return;
      teardownObserver();
      wheelActive = true;

      sectionObs = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry.isIntersecting) return;
          var dir = entry.boundingClientRect.top >= 0 ? 1 : -1;
          currentSlide = dir > 0 ? 0 : totalSlides - 1;
          updateActive(currentSlide, dir);
          wasInView = false;
        },
        { threshold: 0.6 },
      );
      sectionObs.observe(container);

      window.addEventListener("wheel", onWheel, { passive: false });
    };

    var deactivateWheel = function () {
      if (!wheelActive) return;
      wheelActive = false;
      window.removeEventListener("wheel", onWheel, { passive: false });
      if (sectionObs) {
        sectionObs.disconnect();
        sectionObs = null;
      }
      currentSlide = 0;
      wasInView = false;
      updateActive(0, 1);
      initObserver();
    };

    var initObserver = function () {
      if (!track) return;
      track.addEventListener("scroll", onTrackScroll, { passive: true });
    };

    var teardownObserver = function () {
      if (!track) return;
      track.removeEventListener("scroll", onTrackScroll);
    };

    var mq = window.matchMedia("(min-width: 1280px)");

    if (config.enableWheel) {
      if (mq.matches) {
        activateWheel();
      } else {
        updateActive(0, 1);
        initObserver();
      }

      mq.addEventListener("change", function (e) {
        if (e.matches) activateWheel();
        else deactivateWheel();
      });
    } else {
      updateDots(0);
      initObserver();
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        if (config.enableWheel && mq.matches) {
          if (currentSlide > 0) {
            currentSlide--;
            updateActive(currentSlide, -1);
          }
        } else {
          var targetIdx = getPrevSlideIndex();
          currentSlide = targetIdx;
          updateDots(currentSlide);
          scrollToSlide(currentSlide);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        if (config.enableWheel && mq.matches) {
          if (currentSlide < totalSlides - 1) {
            currentSlide++;
            updateActive(currentSlide, 1);
          }
        } else {
          var targetIdx = getNextSlideIndex();
          currentSlide = targetIdx;
          updateDots(currentSlide);
          scrollToSlide(currentSlide);
        }
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        var dir = i >= currentSlide ? 1 : -1;
        currentSlide = i;
        if (config.enableWheel && mq.matches) {
          updateActive(i, dir);
        } else {
          updateDots(i);
          scrollToSlide(i);
        }
      });
    });
  }

  initAppSlider({
    selector: "[data-advantages-wrapper]",
    prefix: "advantages",
    containerClass: "s-advantages__slider-container",
    enableWheel: true,
  });

  initAppSlider({
    selector: "[data-events-wrapper]",
    prefix: "events",
    containerClass: "s-events__slider-wrapper",
    enableWheel: false,
  });
})();
